module.exports = __webpack_public_path__ + "img/ecash_logo.4633feea.png";